<template>
	<div class="base-content">
		<van-cell-group>
			<van-cell is-link title="日期" :value="currentDateShow" @click="openDateTime()" />
		</van-cell-group>
		<van-popup v-model="show" position="bottom" :style="{ height: '50%' }">
			<van-datetime-picker v-model="currentDate" type="date" :min-date="minDate" :max-date="maxDate" @confirm="confirm()"
			 @cancel="cancel()" />
		</van-popup>

		<div class="space"></div>

		<van-row class="padding-bottom">
			<van-col span="8">
				<div class="number-red-blod text-center">{{totalData.teacherNum}}</div>
				<div class="text-title-3 text-center">总人数</div>
			</van-col>
			<van-col span="8">
				<div class="number-yellow-blod text-center">{{totalData.passInNum}}</div>
				<div class="text-title-3 text-center">当日进校人次</div>
			</van-col>
			<van-col span="8">
				<div class="number-green-blod text-center">{{totalData.passOutNum}}</div>
				<div class="text-title-3 text-center">当日出校人次</div>
			</van-col>
		</van-row>
		<van-row class="padding-bottom">
			<van-col span="8">
				<div class="number-red-blod text-center">{{totalData.tempResonableUserNum}}</div>
				<div class="text-title-3 text-center">正常体温人数</div>
			</van-col>
			<van-col span="8">
				<div class="number-yellow-blod text-center">{{totalData.tempUnresonableUserNum}}</div>
				<div class="text-title-3 text-center">异常体温人数</div>
			</van-col>
			<van-col span="8">
				<div class="number-green-blod text-center">{{totalData.noReportTempUserNum}}</div>
				<div class="text-title-3 text-center">未上报</div>
			</van-col>
		</van-row>

		<van-row class="sub-title">
			<van-col span="7"></van-col>
			<van-col span="4" class="text-title-2 number-black text-center">总人数</van-col>
			<van-col span="4" class="text-title-2 number-green text-center">体温正常</van-col>
			<van-col span="4" class="text-title-2 number-red text-center">体温异常</van-col>
			<van-col span="4" class="text-title-2 number-black text-center">未上报</van-col>
			<van-col span="1"></van-col>
		</van-row>

		<div class="content-box">
			<van-row class="sub-content" @click="goDetail(item.scId)" v-for="item of backData" :key="item.id">
				<van-col span="7" class="text-title-2">{{item.scName}}</van-col>
				<van-col span="4" class="text-title-2 number-black text-center">{{item.teacherNum}}</van-col>
				<van-col span="4" class="text-title-2 number-green text-center">{{item.tempResonableUserNum}}</van-col>
				<van-col span="4" class="text-title-2 number-red text-center">{{item.tempUnresonableUserNum}}</van-col>
				<van-col span="4" class="text-title-2 number-black text-center">{{item.noReportTempUserNum}}</van-col>
				<van-col span="1" class="text-title-2 number-black text-center">
					<van-icon name="arrow" class="icon" />
				</van-col>
			</van-row>

		</div>

		<van-overlay :show="showLoading">
			<van-loading size="30px" color="#FFFFFF" vertical class="margin-8">加载中...</van-loading>
		</van-overlay>

		<bottom-tab></bottom-tab>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Col,
		Row
	} from "vant";
	import {
		Icon
	} from "vant";
	import axios from "axios";
	import commonObj from '../../common/common.js'
	import api from "../../http/api";
	import {
		Overlay
	} from "vant";
	import {
		Loading
	} from "vant";
	Vue.use(Col);
	Vue.use(Row);
	Vue.use(Icon);
	Vue.use(Overlay);
	Vue.use(Loading);

	export default {
		data() {
			return {
				showLoading: false,
				schoolIds: [],
				show: false,
				minDate: new Date(2019, 0, 1),
				maxDate: new Date(2030, 11, 31),
				currentDate: this.getSession("manorTchDailycurrentDate") ?
					new Date(this.getSession("manorTchDailycurrentDate")) : new Date(),
				currentDateShow: this.getSession("manorTchDailycurrentDateShow") ||
					this.formatDate(new Date(), "yyyy/MM/dd"),
				backData: [],
				totalData: {
					teacherNum: 0,
					passInNum: 0,
					passOutNum: 0,
					tempResonableUserNum: 0,
					tempUnresonableUserNum: 0,
					noReportTempUserNum: 0
				}
			};
		},

		//列表页处理数据缓存， 直接照搬使用， 变量使用需要返回到前一页的路由
		beforeRouteLeave(to, from, next) {
			if (to.path == "/") {
				this.clearSession("manorTchDailyList");
				this.clearSession("manorTchDailyTotal");
				this.clearSession("manorTchDailySchoolIds");
				this.clearSession("manorTchDailycurrentDate");
				this.clearSession("manorTchDailycurrentDateShow");
			}
			next();
		},

		created: function() {
			// 先获取是否存在 schoolIds
			let schoolIds = this.getSession("manorTchDailySchoolIds");
			if (schoolIds) {
				this.schoolIds = JSON.parse(schoolIds);
				this.loadData();
				return;
			}

			//页面进来根据写死的区域 id:36 获取学校的 ids
			let key = 'school_' + 36 + '_areaTempInfo'
			api.loadAreaTempInfo(key).then(res => {
				let configValue = JSON.parse(res.data.data.configValue).managerSchoolIds;
				this.schoolIds = configValue;
				this.putSesstion(
					"manorTchDailySchoolIds",
					JSON.stringify(this.schoolIds)
				);
				this.loadData();
			});
		},
		methods: {
			clearSession(key) {
				window.sessionStorage.removeItem(key);
			},
			putSesstion(key, value) {
				window.sessionStorage.setItem(key, value);
			},
			getSession(key) {
				return window.sessionStorage.getItem(key);
			},
			//根据日期查询列表数据
			loadData() {
				//页面进入时先获取缓存存储的数据
				let manorTchDailyList = this.getSession("manorTchDailyList");
				let manorTchDailyTotal = this.getSession("manorTchDailyTotal");
				if (manorTchDailyList) {
					this.backData = JSON.parse(manorTchDailyList);
					this.totalData = JSON.parse(manorTchDailyTotal);
					return;
				}

				//否则加载数据
				this.showLoading = true;
				let data =
					`start=${this.currentDateShow} 00:00:00&end=${this.currentDateShow} 23:59:59&schoolIds=${this.schoolIds}`;
				axios({
					url: commonObj.BASEURL + "/temp/school/teacher/dateRange/report?" + encodeURI(data),
					method: "get"
				}).then(res => {
					if (res.data.code == 200) {
						this.showLoading = false; //关闭 loading
						this.backData = res.data.data;
						//每次刷新数据之前先清空数据
						this.totalData = {
							teacherNum: 0,
							passInNum: 0,
							passOutNum: 0,
							tempResonableUserNum: 0,
							tempUnresonableUserNum: 0,
							noReportTempUserNum: 0
						};
						for (let i = 0; i < this.backData.length; i++) {
							this.totalData.teacherNum += this.backData[i].teacherNum;
							this.totalData.passInNum += this.backData[i].passInNum;
							this.totalData.passOutNum += this.backData[i].passOutNum;
							this.totalData.tempResonableUserNum += this.backData[
								i
							].tempResonableUserNum;
							this.totalData.tempUnresonableUserNum += this.backData[
								i
							].tempUnresonableUserNum;
							this.totalData.noReportTempUserNum += this.backData[
								i
							].noReportTempUserNum;
						}
						//数据加载完成之后将数据缓存
						this.putSesstion(
							"manorTchDailyTotal",
							JSON.stringify(this.totalData)
						);
						this.putSesstion("manorTchDailyList", JSON.stringify(this.backData));
					} else if (res.data.code == 10002) {
						this.showLoading = false;
						Toast(res.data.msg);
					}
				});
			},
			openDateTime() {
				this.show = true;
			},
			cancel() {
				this.show = false;
			},
			confirm() {
				this.show = false;
				this.currentDate = new Date(this.currentDate);
				this.currentDateShow = this.formatDate(this.currentDate, "yyyy/MM/dd");

				this.putSesstion("manorTchDailycurrentDate", this.currentDate);
				this.putSesstion("manorTchDailycurrentDateShow", this.currentDateShow);

				this.clearSession("manorTchDailyList");
				this.clearSession("manorTchDailyTotal");

				this.loadData();
			},
			formatDate(date, fmt) {
				date = date == undefined ? new Date() : date;
				date = typeof date == "number" ? new Date(date) : date;
				fmt = fmt || "yyyy-MM-dd HH:mm:ss";
				let obj = {
					y: date.getFullYear(), // 年份，注意必须用getFullYear
					M: date.getMonth() + 1, // 月份，注意是从0-11
					d: date.getDate(), // 日期
					q: Math.floor((date.getMonth() + 3) / 3), // 季度
					w: date.getDay(), // 星期，注意是0-6
					H: date.getHours(), // 24小时制
					h: date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, // 12小时制
					m: date.getMinutes(), // 分钟
					s: date.getSeconds(), // 秒
					S: date.getMilliseconds() // 毫秒
				};
				let week = ["天", "一", "二", "三", "四", "五", "六"];
				for (let i in obj) {
					fmt = fmt.replace(new RegExp(i + "+", "g"), function(m) {
						let val = obj[i] + "";
						if (i == "w") return (m.length > 2 ? "星期" : "周") + week[val];
						for (let j = 0, len = val.length; j < m.length - len; j++)
							val = "0" + val;
						return m.length == 1 ? val : val.substring(val.length - m.length);
					});
				}
				return fmt;
			},
			goDetail(id) {
				window.localStorage.setItem('scId', id);
				this.$router.push({
					path: "schTchDaily",
					query: {
						id: id
					}
				});
			}
		}
	};
</script>

<style>
	.base-content {
		padding: 10px 10px 0px 10px;
	}

	.van-hairline--top-bottom::after,
	.van-hairline-unset--top-bottom::after {
		border-width: 0;
	}

	.content-box {
		width: 100%;
		/* height: 329px; */
		overflow: scroll;
	}

	.icon {
		font-size: 0.25rem;
		margin-top: 2px;
	}

	.sub-title {
		width: 100%;
		height: 35px;
		background-color: rgb(241, 241, 241);
	}

	.sub-content {
		width: 100%;
		min-height: 40px;
		border-bottom: 1px solid rgb(241, 241, 241);
	}

	.text-center {
		text-align: center;
	}

	.number-red-blod {
		font-weight: bold;
		color: rgb(255, 0, 0);
		font-size: 0.4rem;
	}

	.number-yellow-blod {
		font-weight: bold;
		color: rgb(255, 204, 0);
		font-size: 0.4rem;
	}

	.number-green-blod {
		font-weight: bold;
		color: rgb(103, 194, 58);
		font-size: 0.4rem;
	}

	.number-black-blod {
		font-weight: bold;
		color: #2c3e50;
		font-size: 0.4rem;
	}

	.number-red {
		color: rgb(255, 0, 0);
		font-size: 0.4rem;
	}

	.number-yellow {
		color: rgb(255, 204, 0);
		font-size: 0.4rem;
	}

	.number-green {
		color: rgb(103, 194, 58);
		font-size: 0.4rem;
	}

	.number-black {
		color: #2c3e50;
		font-size: 0.4rem;
	}

	.text-title-3 {
		font-size: 0.3rem;
	}

	.text-title-2 {
		font-size: 0.24rem;
		white-space: normal;
		padding: 10px 0;
	}

	.padding-bottom {
		padding-bottom: 5px;
		padding-top: 5px;
	}
</style>
